<template>
 <div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
         <div class="searchBox inpBox1">
            <div class="item">
             <el-form-item label="承运商名称:" prop="targetTenantNameLike" >
                <el-select placeholder="请选择" value-key="id"   v-model="searchFrom.targetTenantNameLike" filterable  >
                  <el-option v-for="item in carrierList" :key="item.id" :label="item.tenantName"  :value="item.tenantName"></el-option>
                </el-select>
              </el-form-item>
            </div>
        </div>
        <div class="searchBtnBox">
              <el-form-item>
                  <el-button type="primary" @click="searchFn"  v-if="btnFlg[0]">查询</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary"  @click="resetForm('searchFrom')">重置</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="addClick"  v-if="btnFlg[1]">新增</el-button>
                </el-form-item>
            </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods'
       @row-click="handleRowClick"  style="width: 100%" height="100%"  center border>
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
         <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <div>
              <!-- <el-button type="text" size="mini" @click="editFn(scope.row)">修改</el-button> -->
              <el-button type="text" size="mini" @click="delFn(scope.row)"  v-if="btnFlg[2]">删除</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="targetTenantName"  min-width="260" :formatter="emptyFn" label="承运商名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="goodsTypeNames"  min-width="180" :formatter="emptyFn" label="偏好货物"></el-table-column>
        <el-table-column prop="areaNames"  min-width="270" :formatter="emptyFn" label="常走路线"></el-table-column>
        <el-table-column prop="driverNum"  min-width="130" :formatter="emptyFn" label="司机数量" show-overflow-tooltip></el-table-column>
        <el-table-column prop="vehicleNum"  min-width="130" :formatter="emptyFn" label="车辆数量"></el-table-column>
        <el-table-column prop="createUserName"  min-width="130" :formatter="emptyFn" label="创建人" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createTime"  min-width="160" :formatter="dateTimeFormat" label="创建时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <!-- <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div> -->
     <el-dialog :title="title"  :visible.sync="SQMark" width="450px" class="detail"  :close-on-click-modal="false" @close="closeDialog" :close-on-press-escape="false" center>
       <el-form :inline="true"  :model="SQFrom" ref="SQFrom" :rules="rules1" class="demo-form-inline jiaoyan" label-width="145px" size="mini">
        <div class="inpBox1">
            <div style="margin: 28px 0;">
              <el-form-item label="选择承运商:" prop="openTenantNameLike" >
                <el-select placeholder="请选择" value-key="id"   v-model="SQFrom.openTenantNameLike1" filterable >
                  <el-option v-for="item in carrierList" :key="item.id" :label="item.tenantName"  :value="item"></el-option>
                </el-select>
              </el-form-item>
             </div>
        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="SQMark = false">取消</el-button>
        <el-button type="primary" @click="SQsave()" v-show="addBtnShow">确定</el-button>
        <!-- <el-button type="primary" @click="editSave()" v-show="editBtnShow">修改</el-button> -->
      </span>
   </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import {
  selectFleetTenantList, // 选择承运商
  sTenantUserBindingRelAdd, // 承运商保存
  sTenantUserBindingRelDelete // 删除
} from '@/api/newCrm'
import { selectTenantLongCarriageList } from '@/api/vgs-driver2.0'
export default {
  data () {
    return {
      carrierList: [],
      title: '',
      addBtnShow: false,
      editBtnShow: false,
      SQFrom: {
        // flag: 1,
        // businessType: 2,
        // targetType: 1
      },
      SQMark: false,
      rules1: {
        openTenantNameLike: [
          { required: true, message: '请选择承运商', trigger: 'blur' }
        ]
      },
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      dialogVisible: false,
      tableList: [],
      searchFrom: {
        // pageNo: 1,
        // pageSize: 50,
        // flag: 1,
        businessType: 2,
        targetType: 1
      },
      total: 0,
      loading: false,
      btnFlg: [],
      btnIdArr: ['00FM0O0100', '00FM0O0200', '00FM0O0300']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/systemManagement/longAssociation')
    this.getList(this.searchFrom)
    // selectTenantListFromCustomer({ businessCode: '00001F', tenantCode: '000' }).then(res => {
    //   this.carrierList = res
    // })
    selectFleetTenantList().then(res => {
      this.carrierList = res
    })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 98) + 'px'
  },
  methods: {
    // 添加
    addClick () {
      this.title = '添加承运商'
      this.addBtnShow = true
      this.editBtnShow = false
      this.SQMark = true
    },
    SQsave () {
      if (this.SQFrom.openTenantNameLike1) {
        this.$set(this.SQFrom, 'openTenantNameLike', this.SQFrom.openTenantNameLike1.tenantName)
        this.$set(this.SQFrom, 'targetTenantCode', this.SQFrom.openTenantNameLike1.tenantCode)
        this.$set(this.SQFrom, 'targetTenantName', this.SQFrom.openTenantNameLike1.tenantName)
      }
      this.$set(this.SQFrom, 'flag', 1)
      this.$set(this.SQFrom, 'businessType', 2)
      this.$set(this.SQFrom, 'targetType', 1)

      this.$refs.SQFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })

          sTenantUserBindingRelAdd(this.SQFrom).then(res => {
            loading.close()
            this.$message({
              message: '添加成功',
              type: 'success'
            })
            this.SQMark = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 修改
    // editFn (row) {
    //   this.title = '修改模块'
    //   this.addBtnShow = false
    //   this.editBtnShow = true
    //   this.SQMark = true
    //   this.SQFrom = {
    //     id: row.id,
    //     name: row.name,
    //     remark: row.remark,
    //     clientClassify: row.clientClassify
    //   }
    // },
    // editSave () {
    //   this.$refs.SQFrom.validate((valid) => {
    //     if (valid) {
    //       const loading = this.$loading({
    //         lock: true,
    //         text: '正在处理...'
    //       })
    //       sModuleUpdate(this.SQFrom).then(res => {
    //         loading.close()
    //         this.$message({
    //           message: '修改成功',
    //           type: 'success'
    //         })
    //         this.SQMark = false
    //         this.getList(this.searchFrom)
    //       }).catch(error => {
    //         this.$message({
    //           showClose: true,
    //           message: error.message,
    //           type: 'error',
    //           onClose () {
    //             loading.close()
    //           }
    //         })
    //       })
    //     }
    //   })
    // },
    // 删除
    delFn (row) {
      if (row.tenantCode != localStorage.getItem('tenantCode')) {
        return this.$message.error('该条数据无删除权限！')
      }
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        sTenantUserBindingRelDelete({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList () {
      this.loading = true
      selectTenantLongCarriageList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res
        // this.total = res.total
      })
    },
    // // 每页条数
    // handleSizeChange (val) {
    //   this.searchFrom.pageSize = val
    //   this.getList(this.searchFrom)
    // },
    // // 当前页
    // handleCurrentChange (val) {
    //   this.searchFrom.pageNo = val
    //   this.getList(this.searchFrom)
    // },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        businessType: 2,
        targetType: 1
        // pageNo: 1,
        // pageSize: 50,
        // createTime: null
      }
    },
    closeDialog () {
      this.$refs['SQFrom'].clearValidate()
      this.SQFrom = {
      }
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox1 .el-date-editor{
  width: 350px!important;
}
/deep/ .checkboxBox{
  display: flex;
  label{
    flex-shrink: 0;
  }
  .el-checkbox-group{
    width:250px ;
  }
}
.jiage .el-form-item__content {
  position: relative;
  .identiCode1 {
    position: absolute;
    right: 14px;
    color: #409eff;
  }
  .danwei1 {
    position: absolute;
    right: 14px;
    color: white;
    padding: 7px 4px;
  }
}
/deep/.inpBox1 .el-input__inner {
    width: 180px;
}
</style>
